import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// Prop 'noAnimation' für Animation-Ausnahme
import "./ProjectSummary.css";

export default function ProjectSummary({
  image,
  video,
  eyebrow,
  title,
  link,
  noAnimation,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (noAnimation) {
      setVisible(true);
      return;
    }
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [noAnimation]);

  return (
    <div
      className={`project-summary${visible ? " project-summary-visible" : ""}`}
      ref={ref}
    >
      <div className="project-summary-image-container">
        {video ? (
          <video
            className="project-summary-image"
            src={video}
            autoPlay
            muted
            loop
            playsInline
          />
        ) : (
          <img className="project-summary-image" src={image} alt={title} />
        )}
      </div>
      <div className="project-summary-eyebrow">{eyebrow}</div>
      <div className="project-summary-title">{title}</div>
      <div></div> {/* This empty div aligns my links properly to left */}
      <Link className="project-summary-link" to={link}>
        See project
      </Link>
    </div>
  );
}
